import moment from 'moment';

export const generateYearOptionsFrom = (fromDate) => {
  let toYear = moment().year() + 1;
  const fromYear = +moment(fromDate) - 2;

  const options = [];

  while (toYear >= fromYear) {
    options.push({
      label: toYear,
      value: toYear,
    });
    toYear--;
  }

  return options;
};

type FormErrorValue = string | string[] | Record<string, string> | undefined;

export const getFormErrorText = (error: FormErrorValue): string | undefined => {
  if (Array.isArray(error)) {
    return error[0];
  }

  if (typeof error === 'string') {
    return error;
  }

  return undefined;
};
